import { MuPowerInputLayerIds } from "fond/types";

export const muPowerInputLayers = [
  {
    key: MuPowerInputLayerIds.boundary,
    title: "Boundary",
    icon: "polygon" as const,
  },
  {
    key: MuPowerInputLayerIds.addresses,
    title: "Addresses",
    icon: "points" as const,
  },
  {
    key: MuPowerInputLayerIds.parcels,
    title: "Parcels",
    icon: "polygon" as const,
  },
  {
    key: MuPowerInputLayerIds.streets,
    title: "Streets",
    icon: "line" as const,
  },
  {
    key: MuPowerInputLayerIds.poles,
    title: "Poles",
    icon: "points" as const,
  },
];

export const getBaseName = (fileName: string): string => {
  return fileName.split(".")[0].toLowerCase();
};

export const fileNameToLayerId = (baseName: string): string | null => {
  const normalizedName = baseName.toLowerCase();
  if (normalizedName === "addresses") return MuPowerInputLayerIds.addresses;
  if (normalizedName === "parcels") return MuPowerInputLayerIds.parcels;
  if (normalizedName === "streets") return MuPowerInputLayerIds.streets;
  if (normalizedName === "poles" || normalizedName === "aer_points") return MuPowerInputLayerIds.poles;
  if (normalizedName === "boundary") return MuPowerInputLayerIds.boundary;
  return null;
};

export interface GroupedLayerFiles {
  layerKey: string;
  baseName: string;
  files: File[];
}

/**
 * Groups dropped files by basename and matches them to layer IDs.
 * Returns matched layers and any unmatched basenames.
 *
 * E.g. dropping [boundary.shp, boundary.dbf, boundary.prj, addresses.geojson, unknown.csv]
 * yields matched: [{layerKey: "raw_data/boundary", files: [boundary.shp, ...]}, ...]
 * and unmatchedNames: ["unknown"]
 */
export const groupFilesByLayer = (files: File[]): { matched: GroupedLayerFiles[]; unmatchedNames: string[] } => {
  const groups = new Map<string, File[]>();
  for (const file of files) {
    const base = getBaseName(file.name);
    if (!groups.has(base)) {
      groups.set(base, []);
    }
    groups.get(base)!.push(file);
  }

  const matched: GroupedLayerFiles[] = [];
  const unmatchedNames: string[] = [];

  for (const [base, groupFiles] of groups) {
    const layerKey = fileNameToLayerId(base);
    if (layerKey) {
      matched.push({ layerKey, baseName: base, files: groupFiles });
    } else {
      unmatchedNames.push(base);
    }
  }

  return { matched, unmatchedNames };
};
